import { Logger } from "./helpers";
import { WorkerScope } from "./models";
import { handleMessageBuilder } from "./handle-message";
import { parseLogsBuilder } from "./parse-logs";

const worker = self as unknown as WorkerScope;
worker.mainLogger = Logger.createInstance('Tracking Web Worker', '#f58231');
worker.initLogger = worker.mainLogger.withPrefix('Init', '#469990');
worker.logLogger = worker.mainLogger.withPrefix('Log', '#42d4f4');
worker.logs = [];
worker.ranOnce = false;

const handleMessage = handleMessageBuilder(worker);
const parseLogs = parseLogsBuilder(worker);
worker.addEventListener("message", handleMessage);

parseLogs();
